import { TextField, SxProps, Theme } from "@mui/material";
import { useTranslate } from "src/locales";

interface ByzMuiTextFieldProps extends React.ComponentProps<typeof TextField> {
    placeholder?: string;
    noPlaceholder?: boolean;
    label?: string;
    cantChange?: boolean;
}

const ByzMuiTextField: React.FC<ByzMuiTextFieldProps> = ({ placeholder, noPlaceholder, label, sx, size = "small", cantChange = false, disabled, ...props }) => {
    const { t } = useTranslate();

    // cantChange true ise disabled true yap ama stil değişmesin
    const isDisabled = disabled || cantChange;

    const defaultSx: SxProps<Theme> = {
        "& .MuiInputLabel-root:not(.Mui-disabled)": {
            color: "#2498f3 !important",
        },
        "& .MuiInputLabel-root.Mui-focused:not(.Mui-disabled)": {
            color: "#2498f3 !important",
        },
        "& .MuiFormLabel-root:not(.Mui-disabled)": {
            color: "#2498f3 !important",
        },
        "& .MuiFormLabel-root.Mui-focused:not(.Mui-disabled)": {
            color: "#2498f3 !important",
        },
        "& .MuiOutlinedInput-root:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline": {
            borderColor: "#2498f3 !important",
        },
        "& .MuiOutlinedInput-root:hover:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline": {
            borderColor: "#2498f3 !important",
        },
        "& .MuiOutlinedInput-root.Mui-focused:not(.Mui-disabled) .MuiOutlinedInput-notchedOutline": {
            borderColor: "#2498f3 !important",
        },
        "& .MuiOutlinedInput-root": {
            ...(!props.multiline && {
                height: size === "small" ? "36px" : "auto",
            }),
        },
        // cantChange durumunda disabled stili uygulanmasın, normal görünsün
        ...(cantChange && {
            "& .MuiInputBase-root.Mui-disabled": {
                backgroundColor: "transparent",
                color: "inherit",
                WebkitTextFillColor: "inherit",
                cursor: "not-allowed",
            },
            "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "inherit",
                cursor: "not-allowed",
            },
            "& .MuiInputLabel-root.Mui-disabled": {
                color: "#2498f3 !important",
            },
            "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                borderColor: "#2498f3 !important",
            },
            "& .MuiOutlinedInput-root.Mui-disabled:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#2498f3 !important",
            },
        }),
    };

    const mergedSx = { ...defaultSx, ...sx };

    // noPlaceholder true ise placeholder boş, değilse verilen veya default
    const resolvedPlaceholder = noPlaceholder ? "" : (placeholder ?? t("enter-text"));

    return (
        <TextField
            placeholder={resolvedPlaceholder}
            label={label}
            size={size}
            InputLabelProps={{ shrink: true }}
            disabled={isDisabled}
            sx={mergedSx}
            {...props}
        />
    );
};

export default ByzMuiTextField;
